const prototypeExtensions = [
    "Array.clean",
    "Array.distinct",
    "Array.every",
    "Array.filter",
    "Array.forEach",
    "Array.indexOf",
    "Array.lastIndexOf",
    "Array.map",
    "Array.reduce",
    "Array.reduceRight",
    "Array.some",
    "Array.sortBy",
    "String.endsWith",
    "String.compare",
    "String.format",
    "String.startsWith",
    "String.trim",
    "String.trimLeft",
    "String.trimRight",
    "Object.toCommaThousands"
];

prototypeExtensions.forEach((module) => {
    require(`./PrototypeExtensions/${module}.js`);
});



// WEBPACK FOOTER //
// ./content/js/PrototypeExtensionsEntry.js